import { Fragment } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import RootRouter from "./routes/RootRouter";

import './assets/fonts/fonts.css'
import "./App.css";
import "./styles/App.scss";

function App() {
  return (
    <Fragment>
      <CssBaseline />
      <RootRouter />
    </Fragment>
  );
}

export default App;
